import React from 'react';
import { connect } from 'react-redux';
import { firstError } from '@/utils/errors';
import ErrorMessage from '@/components/errors/ErrorMessage';
import { cohortReadError } from '@/cohorts/helper';
import fetch from '../datasets/hooks/fetch';
import { fetchRequestCatalogue } from '../datasets/actions';
import { requestSources } from '../constants';
import RequestSourceHeader from '../components/RequestSourceHeader';
import RequestDestinationForm from './RequestDestinationForm';
import { newRequest, requestDatasetCode, resolveRequestWorkflow } from '../state/state';

const RequestDestinationInfo = ({
  category,
  code,
  compact,
  datasetCode,
  fetchData,
  name,
  readStatus,
  sourceCode,
  sourceReadErrors,
  sourceType,
  validationErrors,
}) => {
  fetch.useFetchRequestCatalogue(fetchData, category, code, datasetCode, readStatus);
  const error = validationErrors.length > 0 ? cohortReadError(validationErrors) : firstError(sourceReadErrors);

  return (
    <div className="aridhia-request-destination-info aridhia-wizard-content">
      {name && (<RequestSourceHeader category={sourceType} code={sourceCode} name={name} />)}
      {error && (<ErrorMessage error={error} />)}
      {!error && (<RequestDestinationForm category={category} code={code} compact={compact} />)}
    </div>
  );
};

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request, source } = resolveRequestWorkflow(requests, workflows, ownProps, newRequest(ownProps));
  const safeSource = source || { code: null };

  return ({
    datasetCode: requestDatasetCode(request, safeSource),
    name: request.request_source === requestSources.COHORT ? safeSource.name : safeSource.catalogue?.title,
    readStatus: safeSource.catalogueReadStatus,
    sourceCode: safeSource.code,
    sourceReadErrors: safeSource.readErrors,
    sourceType: request.request_source,
    validationErrors: safeSource.validationErrors || [],
  });
};

const mapDispatchToProps = {
  fetchData: fetchRequestCatalogue,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestDestinationInfo);
